import React from 'react'
import { Box, Heading, Text, Table } from '@workwhile/ui'
import { ColumnDef } from '@tanstack/react-table'
import { useW2WorkStatusSummary } from 'queries/w2/useW2WorkStatusSummary'
import { W2WorkStatusSummaryItem } from 'api/w2/status'

export default function WorkStatusSummary() {
  const { data = [], isLoading, error } = useW2WorkStatusSummary()

  const columns: ColumnDef<W2WorkStatusSummaryItem>[] = [
    {
      header: 'Work Week',
      accessorKey: 'workWeek',
      cell: ({ row }) => row.original.workWeek ?? 'Retroactive',
    },
    { header: 'Status', accessorKey: 'status' },
    {
      header: 'Count',
      accessorKey: 'workCount',
      cell: ({ row }) => (
        <span style={{ textAlign: 'right' }}>{row.original.workCount}</span>
      ),
    },
  ]

  return (
    <Box p={4}>
      <Heading level={2} mb={3}>
        W2 Work Status Summary
      </Heading>
      <Heading level={3} mb={3}>
        ({new Date().toLocaleString('en-US')})
      </Heading>{' '}
      {isLoading ? <Text>Loading…</Text> : null}
      {error ? <Text color="error">Failed to load data</Text> : null}
      {!isLoading && !error ? (
        <Table columns={columns} data={data} enableSorting />
      ) : null}
    </Box>
  )
}
